import { SpacerWrapper } from '@ahmdigital/ui';
import styled from 'styled-components';

export const StyledNeedsCTA = styled(SpacerWrapper)`
  font-size: 1.25rem;
  line-height: 1.875rem;
`;
